export default __webpack_public_path__ + "static/img_product_cample-c12b5d90015daebb8fc7e3781187b125.png";